import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { I2gNgTrackingService, ITrackingObject } from 'i2g-ng-tracking';
import { CancelChangeEmailSuccessBuilder } from './cancel-change-email-success.builder';
import { Observable } from 'rxjs';
import { AccountStore } from '../../store/stores';
import { shareReplay } from 'rxjs/operators';
import { AlignmentEnum, IconSizesEnum, IIcon, IRouter } from 'i2g-ng-ui';

@Component({
  selector: 'app-cancel-change-email-success',
  templateUrl: './cancel-change-email-success.component.html',
  styleUrls: ['./cancel-change-email-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [CancelChangeEmailSuccessBuilder],
})
export class CancelChangeEmailSuccessComponent
  implements OnInit, AfterViewInit {
  successIcon: IIcon;
  trackingScreenName: TrackingScreenNamesEnum;
  trackingObject$: Observable<ITrackingObject>;
  loginRoute: IRouter;
  alignmentEnum: typeof AlignmentEnum;

  constructor(
    private _router: Router,
    private _trackingService: I2gNgTrackingService,
    private _accountStore: AccountStore,
    private _cancelChangeEmailSuccessBuilder: CancelChangeEmailSuccessBuilder
  ) {}

  ngOnInit() {
    this.trackingScreenName = TrackingScreenNamesEnum.change_email_cancel;
    this.trackingObject$ = this._accountStore
      .getTrackingObject()
      .pipe(shareReplay(1));
    this.loginRoute = this._cancelChangeEmailSuccessBuilder.buildLoginRoute();
    this.alignmentEnum = AlignmentEnum;

    this.successIcon = {
      name: 'success',
      size: IconSizesEnum.custom,
    };
  }

  ngAfterViewInit() {
    this._trackingService.trackPage(this.trackingScreenName);
  }
}
